import React from "react";

const HoursAvailabilityCell = ({
  availableFromTime,
  availableToTime,
}: {
  availableFromTime: string;
  availableToTime: string;
}) => {
  return <span>{`${availableFromTime} - ${availableToTime}`}</span>;
};

export default HoursAvailabilityCell;
